import { render } from "./CompetencyMatrix.vue?vue&type=template&id=d4b4071a"
import script from "./CompetencyMatrix.vue?vue&type=script&lang=js"
export * from "./CompetencyMatrix.vue?vue&type=script&lang=js"
script.render = render

export default script